import { combineEpics } from 'redux-observable';

import getAvailabilityStoresEpic from './getAvailabilityStores';
import getBOPISFreeGiftAvailabilityStoresEpic from './getBOPISFreeGiftAvailabilityStores';

export const bopisEpic = combineEpics(getAvailabilityStoresEpic, getBOPISFreeGiftAvailabilityStoresEpic);